import { render, staticRenderFns } from "./ContactDistributionsByPlatform.vue?vue&type=template&id=4ffbd810&scoped=true"
import script from "./ContactDistributionsByPlatform.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByPlatform.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByPlatform.vue?vue&type=style&index=0&id=4ffbd810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffbd810",
  null
  
)

export default component.exports